/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import { PurchaseOrdersDto, PurchaseOrderStatus } from './purchase-orders.dto';

export const PurchaseOrdersMapper = entity<PurchaseOrdersDto>({
  statusValue: enumeration(PurchaseOrderStatus),
  deliveryDate: date(DateFormat.Date),
});
